// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec3410b8","607":"2c828b92"}[chunkId] + ".chunk.js";
};